/// Routes for anonymus users
import Login from './Login';

export const authRoutes = [
  {
    path: "/auth/login",
    element: <Login />,
  },
];
